import { runtimeEnv } from "config/runtimeEnv";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = runtimeEnv("API_BASE_URL");
const businessType = localStorage?.getItem("businessType");

export const tripApi = async (data) => {
  let url = "";
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  if (data?.id) {
    url = `${env}${API_ENDPOINT.Trip.api + "/" + data?.id}`;
  } else {
    url = `${env}${API_ENDPOINT.Trip.api + "?type=" + data?.type + "&status=" + data?.status + "&dateFrom=" + (data?.dateFrom ? data?.dateFrom : "") + "&dateTo=" + (data?.dateTo ? data?.dateTo : "") + "&page=" + page + "&pageSize=" + data.pageSize + "&search=" + (data?.search ? data?.search : "")}&${businessType}=true`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const sosApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Trip.sosApi}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const cancelTripApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Trip.cancelApi + "/" + data?.id}`;
  const res = await requestInstance.post(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const assignDriverApi = async (data) => {
  let url = "";
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  if (data?.tripId) {
    url = `${env}${API_ENDPOINT.Trip.assignDriverApi + "?tripId=" + data?.tripId + "&page=" + page + "&pageSize=" + data.pageSize + "&search=" + (data?.search ? data?.search : "")}&${businessType}=true`;
  } else {
    url = `${env}${API_ENDPOINT.Trip.assignDriverApi + "?vehicleId=" + data?.vehicleId + "&page=" + page + "&pageSize=" + data.pageSize + "&search=" + (data?.search ? data?.search : "")}&${businessType}=true`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const invoiceApi = async (data) => {
  let url;
  if (data?.magicToken) {
    url = `${env}${API_ENDPOINT.Trip.invoiceApi + "?magicToken=" + data?.magicToken}`;
  } else {
    url = `${env}${API_ENDPOINT.Trip.invoiceApi + "?tripId=" + data?.id}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const invoiceDownloadApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Trip.invoiceDownloadApi + "/" + data?.id}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getReservationDetailsService = async (payloadId) => {
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.bookingDetails.api}${payloadId?.id || payloadId}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const assignSubvendorResponseApi = async (data) => {
  const businessType = localStorage?.getItem("businessType");
  const url = `${env}${API_ENDPOINT.Trip.assignSubvendorResponseApi}?${businessType}=true`;
  const res = await requestInstance.put(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getDriverAssignsApi = async (data) => {
  const businessType = localStorage?.getItem("businessType");
  const url = `${env}${API_ENDPOINT.Trip.assignDriverApi}?tripId=${data?.tripId}&${businessType}=true`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const assignDriverToTripApi = async (data) => {
  const businessType = localStorage?.getItem("businessType");
  const url = `${env}${API_ENDPOINT.Trip.assignDriverToTripApi}?${businessType}=true`;
  const res = await requestInstance.put(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};
